import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const CONSENT_KEY = "cookie_consent_v2";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setShow(true);
  }, []);

  useEffect(() => {
    document.body.style.paddingBottom = show ? "9.5rem" : "";
    return () => { document.body.style.paddingBottom = ""; };
  }, [show]);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    // Release the held Meta Pixel events and record this page view now that consent is given.
    if (window.fbq) { window.fbq("consent", "grant"); window.fbq("track", "PageView"); }
    setShow(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    if (window.fbq) window.fbq("consent", "revoke");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4 animate-fade-up"
    >
      <div className="max-w-3xl mx-auto bg-charcoal text-cream rounded-2xl shadow-xl p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
        <span className="w-9 h-9 rounded-xl bg-cream/15 flex items-center justify-center shrink-0">
          <Cookie size={18} />
        </span>
        <p className="flex-1 text-sm leading-relaxed text-cream/90">
          We use essential cookies to keep you signed in and the service secure. With your permission, we'd
          also like to use Meta (Facebook) advertising cookies to measure our ads. See our{" "}
          <Link to="/privacy" className="underline text-cream hover:text-white">Privacy Policy</Link>.
        </p>
        <div className="shrink-0 flex items-center gap-2">
          <button
            data-testid="cookie-decline-btn"
            onClick={decline}
            className="bg-transparent border border-cream/30 hover:border-cream/60 text-cream font-medium text-sm px-5 py-2.5 rounded-full transition-colors whitespace-nowrap"
          >
            Essential only
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="bg-coral hover:bg-coraldark text-white font-semibold text-sm px-6 py-2.5 rounded-full transition-colors whitespace-nowrap"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};
